import styled from "styled-components";
import { theme } from "../../../config";
import { Tag, Select, Row } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Button } from "../../atoms/Button";
export const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
`;

export const Wrapper = styled.div`
  height: 100%;
  margin-bottom: 100px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const BodyWrapper = styled.div`
  ${theme.defaultBoxShadow};
  background: ${theme.colors.white};
  min-height: 750px;
  border-radius: 8px;
`;

export const Divider = styled.div`
  border: 1px solid ${theme.colors.grey};
`;

export const InputWrapper = styled.div`
  padding: 16px 0;
`;

export const InputContainer = styled(Row)`
  padding: 0 37px;
`;

export const InputField = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .ant-picker {
    border: 1px solid ${theme.colors.neutral.black3};
  }
`;

export const InputLabel = styled.span`
  font-family: "Orkney Bold";
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0px;
  margin-right: 12px;
`;

export const ButtonsWrapper = styled.div`
  padding: 38px 39px 30px 39px;
`;

export const OptionBtn = styled.div<{ isSelected: boolean }>`
  background: #ffffff;
  border: 2px solid;
  ${(props) => (!props.isSelected ? "#00918e" : theme.colors.neutral.black4)};
  border-radius: 4px;
  color: ${(props) =>
    !props.isSelected ? "#00918e" : theme.colors.neutral.black4};
  height: 32px;
  padding: 3px 20px;
  cursor: pointer;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  font-weight: bold;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome, Edge, Opera and Firefox */
`;

export const SelectButtonWrapper = styled.div`
  gap: 8px;
  display: flex;
  margin-bottom: 21px;
  button {
    height: 32px;
    padding: 0 25px;
    font-size: 14px;
    background: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
  button:focus,
  button:hover {
    background: ${theme.colors.secondary};
    color: ${theme.colors.white};
  }
`;

export const DownloadWrapper = styled.div`
  padding: 38px 40px 0px 40px;
`;

export const TagStyled = styled(Tag)`
  height: 25px;
  background: ${theme.colors.custom.darkblue3};
  border-radius: 4px;
  color: ${theme.colors.white};
  padding: 2px 15px;
  margin-right: 5px;
  display: inline-block;
`;

export const ImageWrapper = styled.div`
  text-align: center;
  margin-top: 80px;

  @media (max-width: 1120px) {
    margin-top: 30px;
  }

  @media (max-width: 1300px) {
    margin-top: 20px;
  }
  @media (max-width: 1400px) {
    margin-top: 40px;
  }
  @media (max-width: 1800px) {
    margin-top: 50px;
  }
`;

export const Image = styled.img`
  @media (max-width: 1120px) {
    height: 100px;
  }
  @media (max-width: 1280px) {
    height: 130px;
  }
`;

export const SelectStyled = styled(Select)`
  .ant-select-selector {
    padding: 0px 7px;
  }

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: ${theme.colors.neutral.black2};
    border-radius: 4px;
    ${theme.defaultInputStyle}
    @media ${theme.breakpoints.mobileAndTablet} {
      height: 30px;
      font-size: 12.6px;
      line-height: 16px;
      padding-top: 0;
      width: 100%;
    }
    border: 1px solid;
  }

  .ant-select-selection-overflow-item-rest .ant-select-selection-item {
    padding: 2px 0 0 2px !important;
    background: none !important;
    color: white !important;
    height: 22px !important;
    font-size: 12px !important;
    background: ${theme.colors.custom.darkblue3} !important;
  }

  .ant-select-selection-overflow-item .ant-select-selection-item {
    max-width: 141px;

    @media (max-width: 1810px) {
      max-width: 100px;
    }
    @media (max-width: 1760px) {
      max-width: 100px;
    }
    @media (max-width: 1680px) {
      max-width: 120px;
    }
    @media (max-width: 1630px) {
      max-width: 110px;
    }
    @media (max-width: 1660px) {
      max-width: 100px;
    }
    @media (max-width: 1598px) {
      max-width: 100%;
    }
    @media (max-width: 1315px) {
      max-width: 150px;
    }
    @media (max-width: 1230px) {
      max-width: 120px;
    }
    @media (max-width: 1165px) {
      max-width: 50px;
    }
  }

  &.ant-select:not(.ant-select-customize-input)
    .ant-select-selector:hover:enabled {
    border: 1px solid ${theme.colors.secondary};
  }


  &.ant-select-selector {
    &:focus {
      box-shadow: 0 0 0 2px #acdbda !important;
    }
  }

  .ant-select-selection-item {
    padding: 0px 8px;
    background: ${theme.colors.custom.darkblue3};
    border-radius: 4px;
    color: ${theme.colors.white};
    font-size: 12px;
  }

  .ant-select-selection-overflow-item-rest .ant-select-selection-item {
    padding-top: 2px;
    background: white;
    color: #111111;
    border: none;
  }

  .anticon-close {
    color: ${theme.colors.white};
  }

  .ant-select-selection-placeholder {
    text-align: left;
    padding-left: 2px;
  }
`;

export const DownOutlinedStyle = styled(DownOutlined)`
  position: sticky;
  right: 0;
  margin-left: -22px;
  margin-right: 5px;
`;

export const ButtonStyled = styled(Button)`
  margin-right: 10px;
`;

export const TableWrapper = styled.div`
  thead .ant-table-cell {
    background: ${theme.colors.custom.darkblue3} !important;
    color: ${theme.colors.white};
    font-family: Orkney !important;
    font-size: 14px !important;
    position: sticky;
    top: 0;
  }

  padding: 20px 40px 0px 40px;
`;

export const TotalResultText = styled.p`
  font-family: Orkney;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
`;

export const AnchorStyled = styled.a`
  color: ${theme.colors.blue};
  text-decoration-line: underline;
`;
